import { useState } from "react";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import { formatLocation } from "../utils/locations";
import { ModalShell } from "./ModalShell";

export function NoteModal({ location, onCancel, onSave }) {
  const [note, setNote] = useState(location.note || "");

  return (
    <ModalShell
      icon={<NoteAltIcon />}
      title={`Note for ${formatLocation(location)}`}
      subtitle={location.item_name}
      onClose={onCancel}
    >
      <div className="modal-field">
        <label htmlFor="location-note">Location note</label>
        <textarea
          id="location-note"
          value={note}
          onChange={(event) => setNote(event.target.value)}
        />
      </div>
      <div className="modal-actions">
        <button type="button" className="touch-button" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="touch-button"
          onClick={() => onSave(note.trim() || null)}
        >
          Save
        </button>
      </div>
    </ModalShell>
  );
}
